import { render, staticRenderFns } from "./ConfirmYourCar.vue?vue&type=template&id=0b5b748c"
import script from "./ConfirmYourCar.vue?vue&type=script&lang=js"
export * from "./ConfirmYourCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports